
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
const math = require('../../../../../js-handler/math')

export const tableDetail = {
    entity: 'provider',//name table on the db
    dest: 'provider',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"provider", "elem":"fullcont", "id":"provider-fullcont", "act":"selectOne", "entity":"provider", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"provider", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"provider", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields: ["code", "name", "contact"],
        mainFilterValues: ["", ""],
        andFilterFields: [""],
        andFilterValues: [""],
    }

}

/****************ELEMENTS*****************/
//each element could organize their data diferent
export function organizeRow(data) {

    var newData = []

    if (data.length === 0) {
        newData.push({
            id: 'nothing', colum: [{ label: 'No Results', span: '' },
            { label: '', span: '' },
            { label: '', span: '' },
            { label: '', span: '' }]
        })
        return newData
    }

    data.forEach((elem) => {
        const data_roi = JSON.parse((elem.roi_star && elem.roi_star !== "undefined") ? elem.roi_star : '{"roi_star": 0}');

        newData.push(
            {
                id: elem.id, colum: [{
                    label: elem.name, span: elem.contact,
                    style: {
                        tdClass: 'tdWithAvatar',
                        avatar: elem.avatar,
                        avatarColor: elem.avatarColor,
                        avatarColorLetter: elem.avatarColorLetter,
                        avatarLetter: elem.avatarLetter

                    }
                },
                { label: math.cashFormat(elem.due_amount || 0), span: "" },
                // descomentar para percentiles
                {
                    label: "", span: math.percentFormat(elem.roi || 0),
                    style: {
                        tdClass: 'tdWithBehavior',
                        behaviorStar: data_roi.roi_star
                    }
                },
                { label: elem.phone, span: elem.phone2 },
                { label: elem.bill_to_city, span: elem.bill_to_state }]
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/